import { useTranslation } from 'react-i18next'

import { PaymentRecordedDetail } from '#/entities/shipment'
import { Button } from '#/shared/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '#/shared/ui/dialog'
import { CloseIcon } from '#/shared/ui/icons'

interface PaymentViewModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  paymentId: string
}

function ModalHeader() {
  const { t } = useTranslation()
  return (
    <header className="flex h-13 shrink-0 items-center justify-between gap-2.5 border-b border-gray-200 px-5 py-2.5">
      <DialogTitle className="truncate text-lg font-semibold text-gray-900">
        {t('orderDetails.comment.payment.detail.title')}
      </DialogTitle>
      <DialogClose
        aria-label={t('orderDetails.comment.payment.detail.close')}
        className="flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-gray-500 hover:bg-gray-50 focus-visible:outline-none focus-visible:focus-ring"
      >
        <CloseIcon className="size-3.5" />
      </DialogClose>
    </header>
  )
}

function ModalFooter() {
  const { t } = useTranslation()
  return (
    <footer className="flex shrink-0 items-center justify-end gap-2 border-t border-gray-200 px-5 py-3">
      <DialogClose asChild>
        <Button type="button" size="xs" pressEffect className="px-3.75">
          {t('orderDetails.comment.payment.detail.done')}
        </Button>
      </DialogClose>
    </footer>
  )
}

export function PaymentViewModal({
  open,
  onOpenChange,
  paymentId,
}: PaymentViewModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[480px]">
        <ModalHeader />
        <div className="min-h-0 flex-1 overflow-y-auto">
          <PaymentRecordedDetail paymentId={paymentId} enabled={open} />
        </div>
        <ModalFooter />
      </DialogContent>
    </Dialog>
  )
}
